import { defineMessages } from 'react-intl';

export const ratingInfoMessages = defineMessages({
  title: {
    id: 'customerRatings.ratingInfo.title',
    defaultMessage: 'Hinweise zu Bewertungen',
  },
  ariaLabel: {
    id: 'customerRatings.ratingInfo.aria.label',
    defaultMessage: 'weitere Informationen zu Kundenbewertungen',
  },
});
